import { CookieModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";
import { LeadFormDataService } from "./lead-form-data.service";

export const LeadFormDataModule: Module = {
  name: "LeadFormDataModule",
  modules: [CookieModule],
  providers: [LeadFormDataService],
};
